<!--
 * @Author: Tahiti
 * @Date: 2025-10-20 13:34:19
 * @LastEditors: Tahiti
 * @LastEditTime: 2026-01-06 17:19:41
 * @Description: 
 * @FilePath: /weryai-web/components/InnerSideBar.vue
-->
<template>
    <div class="left-menu flex flex-col w-full h-screen fixed top-0 left-0 backdrop-blur-sm justify-between text-white border-r border-r-third-default group peer z-[60] overflow-y-hidden transition-all duration-300 ease-in-out"
        :class="[
            appStore.toolSidebarOpen
                ? 'bg-black/60 opacity-100'
                : 'bg-transparent opacity-0 pointer-events-none',
        ]" @click.self="handleOutsideClick">
        <div class="flex flex-col h-full bg-[var(--el-menu-bg-color)] overflow-hidden transition-all duration-300 ease-in-out"
            :class="[
                appStore.toolSidebarOpen
                    ? 'min-w-[168px] max-w-[240px] px-4 pb-6'
                    : 'w-0 px-0 pb-0',
            ]" @click.stop>
            <!-- 移动端头部：菜单标题 + 关闭按钮 -->
            <div class="xl:hidden flex items-center justify-between px-2 py-4 border-b border-white/10">
                <span class="text-sm font-bold text-white">{{
                    t('menus.menu')
                }}</span>
                <button type="button" class="p-2 text-white hover:text-white/70 transition-colors"
                    @click="handleOutsideClick">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
            <div class="overflow-y-auto overflow-x-hidden mt-5 xl:mt-5">
                <!-- PC端显示创作按钮 -->
                <create-new class="hidden xl:block"></create-new>
                <ClientOnly>
                    <el-menu :default-active="route.path" class="overflow-y-auto overflow-x-hidden"
                        :unique-opened="true" :collapse="false" :collapse-transition="true" :style="{
                            transition: 'all .3s cubic-bezier(0.4, 0, 0.2, 1)',
                        }" @select="handleMenuSelect">
                        <div v-for="item in filteredLeftMenuEnums" :key="item.path">
                            <div v-if="item.type === 'create'" class="px-3 my-[10px] text-sm text-text-adad">
                                {{ t('menus.Creation') }}
                            </div>
                            <div v-if="item.showBorder" class="w-full my-[10px] h-[1px] bg-white/10"></div>
                            <el-menu-item :index="item.path" class="rounded-lg mb-1 relative">
                                <span class="w-5 h-5 shrink-0" :class="item.icon"></span>

                                <template #title>
                                    <span class="ml-[10px] truncate">{{
                                        item.name
                                    }}</span>
                                </template>
                            </el-menu-item>
                        </div>
                    </el-menu>
                </ClientOnly>
            </div>
            <!-- 底部区域 -->
            <div class="bottom-section !hidden space-y-3 px-2 pb-4">
                <!-- 未登录：显示 VIP 升级按钮 -->
                <VipUpgradeButton v-if="!userInfo" />

                <!-- 已登录：显示金币容器 -->
                <div v-else class="coin-box w-full max-w-[140px] mx-auto" :class="coinContainerClass">
                    <!-- 金币显示 -->
                    <div class="coin-area flex items-center justify-center cursor-pointer py-2 px-3"
                        @click="handleCoinClickToPageJump">
                        <img src="~/assets/images/common/coin.webp" alt="credit" class="w-3.5 h-3.5 mr-1" />
                        <span class="text-white text-xs">
                            {{ formattedBalance }}
                        </span>
                    </div>
                    <!-- VIP信息区域 -->
                    <div class="vip-info-area">
                        <!-- 有会员：显示等级名称 -->
                        <div v-if="vipSubscriptionType"
                            class="flex items-center justify-center py-1.5 px-3 cursor-pointer hover:opacity-80 transition-opacity"
                            @click="handleOpenVipModal">
                            <span class="vip-text text-xs">{{
                                vipLevelName
                            }}</span>
                        </div>
                        <!-- 没会员：显示开通会员 -->
                        <div v-else
                            class="flex items-center justify-center py-1.5 px-3 cursor-pointer hover:opacity-80 transition-opacity"
                            @click="handleOpenVipModal">
                            <span class="vip-text text-xs">{{
                                t('menus.startVip')
                            }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 历史记录抽屉 -->
    <RecentlyUsedDrawer v-model:visible="recentlyUsedDrawerVisible" @close="recentlyUsedDrawerVisible = false" />
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import { useAppStore } from '@/stores/app'
import { emitOpenGoodsModal } from '@/utils/emitter'
import { useI18n } from '~/composables/useI18n'
import { useRoute, navigateTo } from '#imports'
import { useToolsHooks } from '@/utils/useHooks'
import { useUserStore } from '@/stores/user'
import RecentlyUsedDrawer from '@/components/RecentlyUsedDrawer.vue'
import { useRecentlyUsed } from '~/composables/useRecentlyUsed'

const { LeftMenuEnums, handleMenuLinkClick } = useToolsHooks()

// 历史记录
const { hasRecentlyUsed } = useRecentlyUsed()
const recentlyUsedDrawerVisible = ref(false)

// 过滤后的菜单列表（根据条件显示/隐藏历史记录菜单项）
const filteredLeftMenuEnums = computed(() => {
    return LeftMenuEnums.value.filter((item: any) => {
        if (item.type === 'recently-used') {
            return hasRecentlyUsed.value
        }
        return true
    })
})
const { t } = useI18n()
const route = useRoute()
const appStore = useAppStore()
const userStore = useUserStore()
// 处理键盘事件
const handleKeydown = (e: KeyboardEvent) => {
    if (e.key === 'Escape' && appStore.toolSidebarOpen) {
        appStore.setToolSidebarOpen(false)
    }
}

// 用户信息
const userInfo = computed(() => userStore.userInfo)
const balance = computed(() => userStore.balance || 0)

// 格式化金币数量（超过1万用w表示）
const formattedBalance = computed(() => {
    const val = balance.value
    if (val >= 10000) {
        return (val / 10000).toFixed(1) + 'w'
    }
    return val.toString()
})

// VIP 信息
const accountSummary = computed(() => userStore.accountSummary)
const vipSubscriptionType = computed(
    () => accountSummary.value?.sub_info?.subscription_type
)

// VIP 等级名称
const vipLevelName = computed(() => {
    const type = vipSubscriptionType.value
    if (!type) return t('menus.freeUser')

    const levelMap: Record<string, string> = {
        PLAN_ENTRY: t('menus.planEntry'),
        PLAN_BASIC: t('menus.planBasic'),
        PLAN_PRO: t('menus.planPro'),
    }

    return levelMap[type] || t('menus.freeUser')
})

// 金币容器样式类名（根据会员等级）
const coinContainerClass = computed(() => {
    const type = vipSubscriptionType.value
    const classMap: Record<string, string> = {
        PLAN_ENTRY: 'coin-box-entry',
        PLAN_BASIC: 'coin-box-basic',
        PLAN_PRO: 'coin-box-pro',
    }
    return classMap[type] || 'coin-box-free'
})

// 打开VIP弹窗
const handleOpenVipModal = () => {
    emitOpenGoodsModal()
}

// 页面跳转
const handleCoinClickToPageJump = () => {
    if (balance.value == 0) {
        navigateTo('/pricing?tab=yearly')
    } else {
        navigateTo('/pricing?tab=credits')
    }
}
// 组件挂载时检查屏幕尺寸
onMounted(() => {
    // userStore.getAccountSummary()

    window.addEventListener('keydown', handleKeydown)
})

// 组件卸载时移除监听器
onUnmounted(() => {
    window.removeEventListener('keydown', handleKeydown)
})

const handleMenuSelect = (index: string): void => {
    // 历史记录菜单项：打开抽屉而不是跳转
    if (index === '/recently-used') {
        recentlyUsedDrawerVisible.value = true
        return
    }

    appStore.setToolSidebarOpen(false)
    handleMenuLinkClick(index)

}

// 处理外部点击关闭侧边栏
const handleOutsideClick = () => {
    console.log('handleOutsideClick')
    appStore.setToolSidebarOpen(false)
}

watch(
    () => appStore.toolSidebarOpen,
    (newVal: boolean) => {
        document.body.style.overflow = newVal ? 'hidden' : 'auto'
    }
)
</script>

<style scoped lang="less">
.left-menu {
    position: fixed;
    top: 0;
    height: 100vh;
    padding-top: 0;
    flex-direction: column;
    gap: 0.125rem;
    font-size: 0.875rem;
    line-height: 1.375rem;
    overflow-x: hidden;
}

:deep(.el-menu-item) {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    overflow: hidden;

    &.is-active {
        background: var(--el-menu-active-bg);
    }
}

:deep(.el-button--text) {
    color: rgba(255, 255, 255, 0.8);
    transition: all 0.2s ease-in-out;
}

:deep(.el-button--text:hover) {
    color: white;
    background-color: rgba(255, 255, 255, 0.1);
    transform: scale(1.05);
}

:deep(.el-icon) {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

:deep(.el-menu--collapse .el-menu-item) {
    text-align: center;
    padding: 0 20px;
}

@media (max-width: 1023px) {
    :deep(.el-menu) {
        --el-menu-collapse-width: 76px;
    }
}

:deep(.el-tooltip__popper) {
    background-color: rgba(0, 0, 0, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    font-size: 14px;
    padding: 8px 12px;
}

:deep(.el-tooltip__popper .el-popper__arrow::before) {
    background-color: rgba(0, 0, 0, 0.9);
    border: 1px solid rgba(255, 255, 255, 0.2);
}

/* 底部区域 */
.bottom-section {
    flex-shrink: 0;
    overflow: visible;
    position: relative;
    z-index: 50;
    padding-top: 12px;
}

/* 金币容器基础样式 */
.coin-box {
    border-radius: 8px;
    overflow: hidden;
    transition: all 0.3s ease;
}

.coin-area {
    user-select: none;
}

/* VIP信息区域基础样式 */
.vip-info-area {
    position: relative;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
}

/* 无会员样式 */
.coin-box-free {
    border: 1px solid #324a2d;
}

.coin-box-free .vip-info-area {
    background: linear-gradient(90deg, #1f321b 0%, #1b2320 50%, #171f1a 100%);
}

.coin-box-free .vip-info-area::before {
    background: linear-gradient(90deg,
            rgba(169, 255, 201, 0.2) 0%,
            rgba(163, 163, 163, 0) 100%);
}

.coin-box-free .vip-text {
    background: linear-gradient(90deg, #feffb5 0%, #99f768 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* 入门会员样式 (PLAN_ENTRY) */
.coin-box-entry {
    border: 1px solid #2d454a;
}

.coin-box-entry .vip-info-area {
    background: linear-gradient(90deg, #20383a 0%, #1b2123 50%, #171c1f 100%);
}

.coin-box-entry .vip-info-area::before {
    background: linear-gradient(90deg,
            rgba(169, 255, 252, 0.2) 0%,
            rgba(163, 163, 163, 0) 100%);
}

.coin-box-entry .vip-text {
    background: linear-gradient(90deg, #b5ffe6 0%, #68d1f7 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* Basic会员样式 (PLAN_BASIC) */
.coin-box-basic {
    border: 1px solid #4a432d;
}

.coin-box-basic .vip-info-area {
    background: linear-gradient(90deg, #393a20 0%, #23201b 50%, #1f1c17 100%);
}

.coin-box-basic .vip-info-area::before {
    background: linear-gradient(90deg,
            rgba(255, 254, 169, 0.2) 0%,
            rgba(163, 163, 163, 0) 100%);
}

.coin-box-basic .vip-text {
    background: linear-gradient(90deg, #fdffb5 0%, #f7cc68 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}

/* Pro会员样式 (PLAN_PRO) */
.coin-box-pro {
    border: 1px solid #4a432d;
}

.coin-box-pro .vip-info-area {
    background: linear-gradient(90deg, #3a2020 0%, #231b1f 50%, #1f171d 100%);
}

.coin-box-pro .vip-info-area::before {
    background: linear-gradient(90deg,
            rgba(255, 169, 171, 0.2) 0%,
            rgba(163, 163, 163, 0) 100%);
}

.coin-box-pro .vip-text {
    background: linear-gradient(90deg, #ffc0b5 0%, #f76868 100%);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
}
</style>
